import React, { useState, useEffect } from "react";
import {
  Box,
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  Typography,
  CircularProgress,
  Alert,
  Paper,
} from "@mui/material";
import { getSensorDataById } from "../../api"; // API Call

const GenericImageCapture = ({ sensorId }) => {
  const [sensorData, setSensorData] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch sensor data from API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getSensorDataById(sensorId);
        const data = response.data.data || [];
        setSensorData(data);
        if (data.length > 0) {
          setSelectedImage(data[0].data.imageUrl); // Default to first image
        }
      } catch (err) {
        setError("Failed to load sensor data.");
        console.error("Error fetching sensor data:", err);
      } finally {
        setLoading(false);
      }
    };

    if (sensorId) fetchData();
  }, [sensorId]);

  if (loading) return <CircularProgress />;
  if (error) return <Alert severity="error">{error}</Alert>;
  if (!sensorData || sensorData.length === 0) return <Alert severity="info">No images available.</Alert>;

  return (
    <Box display="flex" height="500px">
      {/* Left Sidebar - Image List */}
      <Box width="250px" bgcolor="#f4f4f4" p={2} overflow="auto">
        <Typography variant="h6" gutterBottom>
          Captured Images
        </Typography>
        <List>
          {sensorData.map((item, index) => (
            <ListItemButton key={index} onClick={() => setSelectedImage(item.data.imageUrl)}>
              <Paper elevation={3} sx={{ display: "flex", alignItems: "center", p: 1 }}>
                <img
                  src={item.data.imageUrl}
                  alt={`Thumbnail ${index}`}
                  style={{ width: 50, height: 50, marginRight: 10, borderRadius: 5 }}
                />
                <ListItemText primary={new Date(item.captureTime).toLocaleString()} />
              </Paper>
            </ListItemButton>
          ))}
        </List>
      </Box>

      {/* Right Panel - Full Image Display */}
      <Box flex={1} display="flex" justifyContent="center" alignItems="center" p={2}>
        {selectedImage ? (
          <img src={selectedImage} alt="Full view" style={{ maxWidth: "100%", maxHeight: "400px", borderRadius: 10 }} />
        ) : (
          <Typography variant="h6">Select an image to view</Typography>
        )}
      </Box>
    </Box>
  );
};

export default GenericImageCapture;
